// extracted by mini-css-extract-plugin
export var buttons = "_bp-0";
export var buttonsActive = "_bp-h";
export var cancelConfirm = "_bp-1";
export var closeButton = "_bp-2";
export var column = "_bp-3";
export var container = "_bp-4";
export var detailHeader = "_bp-6";
export var detailTitle = "_bp-7";
export var detailsContent = "_bp-5";
export var header = "_bp-8";
export var headerWithClose = "_bp-9";
export var icon = "_bp-a";
export var infoIcon = "_bp-c";
export var informationContainer = "_bp-b";
export var sideDrawer = "_bp-d";
export var sideDrawerOpen = "_bp-e";
export var stickyFooter = "_bp-f";
export var typeOption = "_bp-g";